import { BELOW_LG } from '@/src/lib/breakpoints';

type ShareableListing = { uriV2?: string; uriMalone?: string };

/**
 * Builds a share URL for a listing with UTM tracking parameters.
 */
export function buildShareUrl(listing: ShareableListing, source: string, medium: string): string {
  const path = listing.uriV2 ?? listing.uriMalone ?? '';
  const base = `https://hotpads.com${path}`;
  const params = new URLSearchParams({
    utm_medium: medium,
    utm_source: source,
    utm_campaign: 'tellafriend',
  });
  return `${base}?${params.toString()}`;
}

/**
 * On mobile (sub-`lg`) with the Web Share API available, open the OS share sheet
 * for the listing and return `true`. Returns `false` otherwise so callers fall
 * back to their own share UI: `if (tryNativeShare(listing)) return;`.
 */
export function tryNativeShare(listing: ShareableListing, onShared?: () => void): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined' || !navigator.share) return false;
  if (!window.matchMedia(BELOW_LG).matches) return false;

  void navigator
    .share({ title: 'HotPads listing', url: buildShareUrl(listing, 'native_share', 'referral') })
    .then(onShared)
    .catch((err: unknown) => {
      // The user dismissing the share sheet rejects with AbortError — not an error.
      if (err instanceof Error && err.name === 'AbortError') return;
    });
  return true;
}
